<template>
  <v-container v-if="cursoToUpdate">
    <v-row justify="center">
      <v-col cols="12">
        <v-btn text class="ui-back-btn" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
      <v-col cols="5">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Programar curso</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-progress-circular :value="activeStep * 50" v-bind="circularProgressProps"></v-progress-circular>
                </v-col>
                <v-col cols="8">
                  <div class="text-caption text--primary">PASO {{ activeStep }}</div>
                  <div class="text-subtitle-1 font-weight-bold text--primary">{{ activeStepTitle }}</div>
                  <a
                    class="text-decoration-none secondary--text step-back-link"
                    v-show="activeStep != 1"
                    v-on:click="activeStep--"
                    >Volver al paso anterior</a
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep == 1">
              <v-form v-model="courseScheduleForm">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        class="ui-form-field"
                        :value="cursoToUpdate.subcategoria"
                        rounded
                        filled
                        dense
                        background-color="transparent"
                        color="secondary"
                        label="Curso"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        class="ui-form-field"
                        background-color="transparent"
                        color="secondary"
                        rounded
                        filled
                        dense
                        :items="capacitadores"
                        item-value="id"
                        item-text="nombreCompleto"
                        v-model="programacionCurso.fk_idCapacitador"
                        :rules="required"
                      >
                        <template v-slot:label
                          >Capacitador que impartirá el curso <span class="red--text">*</span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        class="ui-form-field"
                        label="Aula"
                        background-color="transparent"
                        color="secondary"
                        rounded
                        filled
                        dense
                        :items="aulas"
                        item-value="id"
                        item-text="aula"
                        v-model="programacionCurso.fk_idAula"
                        :rules="required"
                      >
                        <template v-slot:label>Aula <span class="red--text">*</span> </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-container>
            <v-container v-else>
              <v-form v-model="periodoCursoForm">
                <v-row>
                  <v-col cols="12">
                    <v-date-picker
                      v-model="periodoCurso"
                      locale="es"
                      color="secondary"
                      no-title
                      full-width
                      range
                      :rules="required"
                    ></v-date-picker>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      class="ui-form-field"
                      :value="fechaInicio"
                      v-bind="textInputProps"
                      background-color="transparent"
                      label="Fecha incio"
                      disabled
                      readonly
                      :rules="required"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      class="ui-form-field"
                      :value="fechaFin"
                      v-bind="textInputProps"
                      background-color="transparent"
                      label="Fecha fin"
                      disabled
                      readonly
                      :rules="required"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container class="ui-module-actions">
              <v-row>
                <v-col xl="12" align="center">
                  <v-btn
                    color="secondary"
                    class="ui-module-btn-solid ui-step-action-btn"
                    v-on:click="activeStepButtonHandler"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    >{{ activeStepButtonLabel }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  cardActionsProps,
  cardProps,
  cardTitleProps,
  primaryButtonProps,
  textInputProps,
  circularProgressProps,
} from '../../components/props/props'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_CURSO_TO_UPDATE(this.id)
  },

  data() {
    return {
      cardActionsProps,
      cardProps,
      cardTitleProps,
      primaryButtonProps,
      textInputProps,
      circularProgressProps,

      loading: false,
      courseScheduleForm: false,
      periodoCursoForm: false,
      activeStep: 1,
      periodoCurso: [null, null],

      programacionCurso: {
        fk_idSubcategoria: this.id,
        fk_idCapacitador: null,
        fk_idAula: null,
        fechaInicio: null,
        fechaFin: null,
        fk_idEstatusCurso: null,
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('estatusCurso', {
      courseStatus: 'getEstatusCurso',
    }),

    ...mapGetters('curso', {
      cursos: 'getCursos',
    }),

    ...mapGetters('capacitador', {
      capacitadoresList: 'getCapacitadores',
    }),

    capacitadores() {
      return this.capacitadoresList.map((capacitador) => ({
        ...capacitador,
        nombreCompleto: `${capacitador.nombre} ${capacitador.apaterno} ${capacitador.amaterno || ''}`.trim(),
      }))
    },

    ...mapGetters('aula', {
      aulas: 'getAulas',
    }),

    ...mapGetters('curso', {
      cursoToUpdate: 'getCursoToUpdate',
    }),

    activeStepTitle: function () {
      switch (this.activeStep) {
        case 1:
          return 'Información principal'
        case 2:
          return 'Duración del curso'
      }
    },

    activeStepButtonLabel: function () {
      if (this.activeStep < 2) {
        return 'Siguiente paso'
      } else {
        return 'Programar curso'
      }
    },

    validActiveStep: function () {
      switch (this.activeStep) {
        case 1:
          if (this.courseScheduleForm) {
            return true
          } else {
            return false
          }
        case 2:
          if (this.periodoCursoForm) {
            return true
          } else {
            return false
          }
      }
    },

    fechaInicio: function () {
      if (this.periodoCurso[0]) {
        if (moment(this.periodoCurso[1]).isBefore(this.periodoCurso[0])) {
          return moment(this.periodoCurso[1]).format(this.API_DATE_FORMAT)
        } else return moment(this.periodoCurso[0]).format(this.API_DATE_FORMAT)
      }
    },

    fechaFin: function () {
      if (this.periodoCurso[1]) {
        if (moment(this.periodoCurso[1]).isAfter(this.periodoCurso[0])) {
          return moment(this.periodoCurso[1]).format(this.API_DATE_FORMAT)
        } else return moment(this.periodoCurso[0]).format(this.API_DATE_FORMAT)
      }
    },
  },

  methods: {
    ...mapActions('cursoProgramado', ['saveCursoProgramado', 'fetchCursosProgramados']),
    ...mapMutations('curso', ['SET_CURSO_TO_UPDATE']),

    activeStepButtonHandler: async function () {
      if (this.activeStep < 2) {
        this.activeStep++
      } else {
        this.loading = true

        await this.saveCursoProgramado({
          fkidSubcategoria: this.id,
          fkidCapacitador: this.programacionCurso.fk_idCapacitador,
          fkidAula: this.programacionCurso.fk_idAula,
          fechaInicio: this.fechaInicio,
          fechaFin: this.fechaFin,
          fkidEstatusCurso: 1,
        })

        await this.fetchCursosProgramados()
        this.$router.push('/profesionalizacion/cursos')
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ui-back-btn {
  color: #26de81 !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.step-back-link {
  color: #26de81 !important;
  font-weight: 600;
}

::v-deep .v-progress-circular__underlay {
  stroke: rgba(0, 210, 160, 0.18) !important;
}

::v-deep .v-progress-circular__overlay {
  stroke: #26de81 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #26de81 !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .v-date-picker {
  background: rgba(16, 16, 30, 0.92) !important;
  border: 1px solid rgba(0, 210, 160, 0.2) !important;
  border-radius: 16px !important;
}

::v-deep .v-date-picker-header,
::v-deep .v-picker__title {
  background: rgba(0, 210, 160, 0.12) !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #062118 !important;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.28) !important;
}

::v-deep .ui-step-action-btn {
  min-width: 180px;
  padding-left: 24px !important;
  padding-right: 24px !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 210, 160, 0.25) !important;
}

.red--text {
  color: #ff5252 !important;
}
</style>
